/**
 * 全链路监控
 */
const webRum = () => {
  if (typeof window !== 'undefined') {
    try {
      const { InitWebRumSdk } = require('@ju/otel-web-rum');
      InitWebRumSdk({
        serviceName: 'client-web-home',
        serviceNamespace: 'web',
        serviceVersion: process.env.NEXT_PUBLIC_WEB_RUM_serviceVersion,
        exporterUrl: process.env.NEXT_PUBLIC_WEB_RUM_ENDPOINT,
        apiKey: process.env.NEXT_PUBLIC_WEB_RUM_APIKEY,
      });
    } catch (e) {
      console.error('Failed to load otel-web-rum:', e);
    }
  }
}

export default webRum;